import React, { useEffect, useState } from 'react';
import { PageHead, SectionHeader, SectionWrap } from '../../Components';
import './SubsList.css';
import LoadingPage from '../LoadingPage/LoadingPage';

function SubsList() {
    // const apiUrl = 'http://localhost/server/testServer';
    const apiUrl = 'https://www.albarede.com/server';

    const [emailsList, setEmailsList] = useState([]); // قائمة المشتركين العامة
    const [vipEmailsList, setVipEmailsList] = useState([]); // قائمة المشتركين الخاصة
    const [isLoading, setIsLoading] = useState(true);

    // حالات جديدة لحقول إرسال البريد الإلكتروني
    const [emailSubject, setEmailSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [sendEmailStatus, setSendEmailStatus] = useState('');
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [targetAudience, setTargetAudience] = useState('subscribers'); // 'subscribers' أو 'vip'

    // حالات لإدارة إضافة/حذف VIP Emails
    const [newVipEmail, setNewVipEmail] = useState('');
    const [vipEmailStatus, setVipEmailStatus] = useState('');
    const [isAddingVipEmail, setIsAddingVipEmail] = useState(false);

    // حالة لرسائل حذف المشتركين العاديين
    const [subscriberDeleteStatus, setSubscriberDeleteStatus] = useState('');

    useEffect(() => {
        // جلب كلتا القائمتين عند التحميل الأولي
        fetchSubscribers();
        fetchVipSubscribers();
    }, []);

    // دالة لجلب قائمة المشتركين من الخادم
    const fetchSubscribers = () => {
        fetch(`${apiUrl}/subscriber.php`)
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then((data) => {
                setEmailsList(Array.isArray(data) ? data : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching subscribers:', err);
                setSendEmailStatus('فشل في جلب قائمة المشتركين العامة.');
                setIsLoading(false);
            });
    };

    // دالة جديدة لحذف بريد إلكتروني من القائمة العامة
    const handleDeleteSubscriber = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذا البريد الإلكتروني من قائمة المشتركين العامة؟')) return;

        setSubscriberDeleteStatus(''); // مسح أي رسالة سابقة
        try {
            const response = await fetch(`${apiUrl}/subscriber.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                setSubscriberDeleteStatus('تم حذف المشترك بنجاح.');
                fetchSubscribers(); // إعادة جلب القائمة العامة لتحديث العرض
            } else {
                setSubscriberDeleteStatus(`فشل الحذف: ${data.error || 'خطأ غير معروف'}`);
            }
        } catch (error) {
            console.error('Error deleting subscriber:', error);
            setSubscriberDeleteStatus('خطأ في الاتصال بالخادم عند الحذف.');
        }
    };


    // دالة جديدة لجلب قائمة المشتركين الخاصة (VIP)
    const fetchVipSubscribers = () => {
        fetch(`${apiUrl}/vip_subscriber.php`)
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then((data) => {
                setVipEmailsList(Array.isArray(data) ? data : []);
            })
            .catch((err) => {
                console.error('Error fetching VIP subscribers:', err);
                setVipEmailStatus('فشل في جلب قائمة المشتركين المخصصة.');
            });
    };

    // دالة جديدة لإضافة بريد إلكتروني إلى القائمة المخصصة
    const handleAddVipEmail = async () => {
        setVipEmailStatus('');
        if (!newVipEmail.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newVipEmail)) {
            setVipEmailStatus('الرجاء إدخال بريد إلكتروني صحيح.');
            return;
        }

        setIsAddingVipEmail(true);
        try {
            const response = await fetch(`${apiUrl}/vip_subscriber.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: newVipEmail }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                setVipEmailStatus('تم إضافة البريد بنجاح.');
                setNewVipEmail('');
                fetchVipSubscribers(); // إعادة جلب القائمة المخصصة لتحديث العرض
            } else {
                setVipEmailStatus(`فشل الإضافة: ${data.error || 'خطأ غير معروف'}`);
            }
        } catch (error) {
            console.error('Error adding VIP email:', error);
            setVipEmailStatus('خطأ في الاتصال بالخادم عند الإضافة.');
        } finally {
            setIsAddingVipEmail(false);
        }
    };

    // دالة جديدة لحذف بريد إلكتروني من القائمة المخصصة
    const handleDeleteVipEmail = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذا البريد الإلكتروني من القائمة المخصصة؟')) return;

        try {
            const response = await fetch(`${apiUrl}/vip_subscriber.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id }),
            });
            const data = await response.json();
            if (response.ok && data.success) {
                setVipEmailStatus('تم حذف البريد بنجاح.');
                fetchVipSubscribers(); // إعادة جلب القائمة المخصصة لتحديث العرض
            } else {
                setVipEmailStatus(`فشل الحذف: ${data.error || 'خطأ غير معروف'}`);
            }
        } catch (error) {
            console.error('Error deleting VIP email:', error);
            setVipEmailStatus('خطأ في الاتصال بالخادم عند الحذف.');
        }
    };


    // دالة لإرسال البريد الإلكتروني إلى جميع المشتركين (أو المخصصين)
    const handleSendEmail = () => {
        setSendEmailStatus('جارٍ الإرسال...');
        setIsSendingEmail(true);

        if (!emailSubject.trim() || !emailBody.trim()) {
            setSendEmailStatus('الرجاء إدخال الموضوع والرسالة.');
            setIsSendingEmail(false);
            return;
        }

        fetch(`${apiUrl}/send_broadcast_email.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                subject: emailSubject,
                body: emailBody,
                target: targetAudience,
            }),
        })
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    const sentCount = data.sent_count || (targetAudience === 'vip' ? vipEmailsList.length : emailsList.length);
                    let statusMessage = `تم إرسال البريد الإلكتروني بنجاح إلى ${sentCount} مشترك.`;
                    if (data.failed_emails && data.failed_emails.length > 0) {
                        statusMessage = `${statusMessage} فشل الإرسال إلى ${data.failed_emails.length} بريد إلكتروني.`;
                    }
                    setSendEmailStatus(statusMessage);
                    setEmailSubject('');
                    setEmailBody('');
                } else {
                    setSendEmailStatus(`فشل الإرسال: ${data.message || 'خطأ غير معروف'}`);
                }
            })
            .catch((error) => {
                console.error('Error sending email:', error);
                setSendEmailStatus('حدث خطأ أثناء الاتصال بالخادم لإرسال البريد الإلكتروني.');
            })
            .finally(() => {
                setIsSendingEmail(false);
            });
    };

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <>
            <PageHead title='إدارة المشتركين' btn='المكتبة القانونية' hrefBtn='/laws' />
            <SectionWrap>
                {/* قائمة المشتركين العامة */}
                <div className='numberOfList p-4 bg-gray-100 rounded-lg shadow-sm mb-6'>
                    <p className='text-lg font-semibold text-gray-700'>العدد الكلي للمشتركين:</p>
                    <span className='text-2xl font-bold text-blue-600'>{emailsList.length}</span>
                </div>
                <div className='p-4 rounded-lg shadow-sm mb-4'>
                    <h3 className='text-xl font-semibold text-gray-800 mb-4'>عناوين البريد الإلكتروني للمشتركين:</h3>
                    {subscriberDeleteStatus && (
                        <p className={`email-status-message mb-4 ${subscriberDeleteStatus.includes('نجاح') ? 'success' : 'error'}`}>
                            {subscriberDeleteStatus}
                        </p>
                    )}
                    <ul className='articlsTitlsList space-y-2'>
                        {emailsList.length > 0 ? (
                            emailsList.map((emailObj) => (
                                <li key={emailObj.id} className='subListGeneral'>
                                    <span className='text-gray-700'>{emailObj.email}</span>
                                    <button
                                        onClick={() => handleDeleteSubscriber(emailObj.id)}
                                        className='deletBtnSubs'
                                    >
                                        حذف
                                    </button>
                                </li>
                            ))
                        ) : (
                            <p className='text-gray-500'>لا يوجد مشتركين حاليًا.</p>
                        )}
                    </ul>
                </div>

                {/* قسم القائمة المخصصة (VIP) الجديد */}
                <SectionHeader title='القائمة المخصصة (VIP)' />
                <div className='vip-list-section p-6 rounded-lg shadow-lg mb-6'>
                    <h3 className='text-xl font-bold text-gray-800 mb-4'>إدارة قائمة VIP</h3>

                    {/* إضافة بريد إلكتروني VIP */}
                    <div className='add-vip-email-form mb-6'>
                        <label htmlFor='newVipEmail' className='block text-gray-700 text-sm font-bold mb-2'>
                            إضافة بريد إلكتروني جديد إلى VIP:
                        </label>
                        <div className='flex gap-2 flex-wrap'>
                            <input
                                type='email'
                                id='newVipEmail'
                                value={newVipEmail}
                                onChange={(e) => setNewVipEmail(e.target.value)}
                                placeholder='بريد إلكتروني جديد لـ VIP...'
                                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500'
                                disabled={isAddingVipEmail}
                            />
                            <button
                                onClick={handleAddVipEmail}
                                className='bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed'
                                disabled={isAddingVipEmail}
                            >
                                {isAddingVipEmail ? 'جارٍ الإضافة...' : 'إضافة'}
                            </button>
                        </div>
                        {vipEmailStatus && (
                            <p className={`mt-2 text-sm font-semibold ${vipEmailStatus.includes('نجاح') ? 'text-green-700' : 'text-red-700'}`}>
                                {vipEmailStatus}
                            </p>
                        )}
                    </div>

                    {/* عرض قائمة VIP وحذفها */}
                    <h4 className='text-lg font-semibold text-gray-800 mb-3'>قائمة العناوين المخصصة VIP: ({vipEmailsList.length})</h4>
                    <div className='vipList'>
                      <ul className='space-y-2'>
                        {vipEmailsList.length > 0 ? (
                            vipEmailsList.map((emailObj) => (
                                <li key={emailObj.id} className='flex justify-between items-center bg-gray-50 p-2 rounded-md shadow-sm border border-gray-200'>
                                    <span className='text-gray-700'>{emailObj.email}</span>
                                    <button
                                        onClick={() => handleDeleteVipEmail(emailObj.id)}
                                        className='bg-red-500 hover:bg-red-700 text-white text-xs font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out'
                                    >
                                        حذف
                                    </button>
                                </li>
                            ))
                        ) : (
                            <p className='text-gray-500'>لا توجد عناوين بريد إلكتروني في قائمة VIP حاليًا.</p>
                        )}
                    </ul>
                    </div>
                </div>
                {/* نهاية قسم القائمة المخصصة (VIP) */}


                {/* قسم إرسال البريد الإلكتروني (مع اختيار الجمهور) */}
                <div className='sendEmail bg-white p-6 rounded-lg shadow-lg'>
                    <h2 className='text-2xl font-bold text-gray-800 mb-6 text-center'>ارسال بريد إلكتروني</h2>

                    {/* خيارات تحديد الجمهور المستهدف */}
                    <div className='target-audience-selection mb-6'>
                        <label className='block text-gray-700 text-sm font-bold mb-2'>
                            إرسال إلى:
                        </label>
                        <div className='flex items-center gap-2 flex-wrap'>
                            <label className='inline-flex items-center'>
                                <input
                                    type='radio'
                                    className='form-radio text-blue-600 ml-2'
                                    name='audience'
                                    value='subscribers'
                                    checked={targetAudience === 'subscribers'}
                                    onChange={() => setTargetAudience('subscribers')}
                                />
                                <span className='ml-2 text-gray-700'>جميع المشتركين ({emailsList.length})</span>
                            </label>
                            <label className='inline-flex items-center'>
                                <input
                                    type='radio'
                                    className='form-radio text-purple-600 ml-2'
                                    name='audience'
                                    value='vip'
                                    checked={targetAudience === 'vip'}
                                    onChange={() => setTargetAudience('vip')}
                                    disabled={vipEmailsList.length === 0}
                                />
                                <span className='ml-2 text-gray-700'>القائمة المخصصة (VIP) ({vipEmailsList.length})</span>
                            </label>
                        </div>
                    </div>
                    {/* نهاية خيارات تحديد الجمهور المستهدف */}


                    <div className='email-form-group mb-4'>
                        <label htmlFor='emailSubject' className='block text-gray-700 text-sm font-bold mb-2'>
                            الموضوع:
                        </label>
                        <input
                            type='text'
                            id='emailSubject'
                            value={emailSubject}
                            onChange={(e) => setEmailSubject(e.target.value)}
                            placeholder='اكتب موضوع الرسالة هنا...'
                            className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500'
                        />
                    </div>
                    <div className='email-form-group mb-6'>
                        <label htmlFor='emailBody' className='block text-gray-700 text-sm font-bold mb-2'>
                            نص الرسالة:
                        </label>
                        <textarea
                            id='emailBody'
                            value={emailBody}
                            onChange={(e) => setEmailBody(e.target.value)}
                            placeholder='اكتب نص الرسالة هنا...'
                            rows='10'
                            className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500 resize-y'
                        ></textarea>
                    </div>
                    <button
                        onClick={handleSendEmail}
                        className='send-email-btn bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline w-full transition duration-300 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed'
                        disabled={isSendingEmail || (targetAudience === 'vip' && vipEmailsList.length === 0)}
                    >
                        {isSendingEmail ? 'جارٍ الإرسال...' : 'إرسال البريد الإلكتروني'}
                    </button>
                    {sendEmailStatus && (
                        <p
                            className={`email-status-message mt-4 p-3 rounded-lg text-center font-semibold ${
                                sendEmailStatus.includes('نجاح') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                            }`}
                        >
                            {sendEmailStatus}
                        </p>
                    )}
                </div>
            </SectionWrap>
        </>
    );
}

export default SubsList;